import BaseService from './BaseService'
import Schools from '@/models/schools'
import { SchoolFunctions } from '@/models/establishment'

export class SchoolsService extends BaseService<Schools> {
  constructor() {
    super('schools/')
  }

  public async fetchSchoolFunctions(schoolId: number) {
    const response = await this.instance.get<SchoolFunctions>(this.resourcePath + schoolId)
    return response.data
  }

}

export default new SchoolsService()
